module.exports = __webpack_public_path__ + "static/media/up.821c06af.png";